// extracted by mini-css-extract-plugin
module.exports = {"cont":"_93444fe79c--cont--Q4S59","icon":"_93444fe79c--icon--P1UbA"};